<template>
  <div>
    <template>
      <b-modal
        v-model="modalOk"
        :active="modalOk"
        :width="1000"
        :height="500"
        :on-cancel="
          () => {
            modalOk = false
          }
        "
      >
        <div class="card">
          <div class="card-content">
            <header class="modal-card-head">
              <p class="modal-card-title">{{ title }}</p>
              <button class="delete" type="button" @click="closing()"></button>
            </header>

            <template>
              <div>
                <section class="container section page-header section is-main-section">
                  <form @submit.prevent="saveSettings">
                    <div>
                      <card-component>
                        <div class="columns">
                          <div class="column">
                            <drop-down type="forAcadmicYear" :disabled="someParamsVisible"></drop-down>
                          </div>
                          <div class="column">
                            <div class="field">
                              <label class="label">
                                Application Amount
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control  is-fullwidth">
                                <input required class="input" placeholder="Application Amount" @input="exceptEValidation" step="any" :max-height="600" type="number" v-model="amount" />
                              </div>
                            </div>
                          </div>
                          <div class="column">
                            <div class="field">
                              <label class="label">
                                Admission Type
                                <span class="has-text-danger">*</span>
                              </label>

                              <div class="control select is-fullwidth">
                                <select required :disabled="someParamsVisible" v-model="admissionType">
                                  <option value="">---Select---</option>
                                  <option selected value="All Admission">All Admission</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column">
                            <div class="field">
                              <label class="label">
                                Select Class

                                <span class="has-text-danger">*</span>
                              </label>

                              <div class="control is-fullwidth">
                                <multiselect
                                  :disabled="someParamsVisible"
                                  track-by="id"
                                  label="name"
                                  class="overflowmultiselect1"
                                  :close-on-select="false"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  :preselect-first="false"
                                  :multiple="true"
                                  :options="classes"
                                  :max-height="150"
                                  v-model="classIDs"
                                >
                                  >
                                  <template slot="selection" slot-scope="{ values, isOpen }"
                                    ><span class="multiselect__single" v-if="values.role &amp;&amp; !isOpen">{{ values.name }} </span></template
                                  >
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="column">
                            <div class="field">
                              <label class="label">
                                Select Franchisee

                                <span class="has-text-danger">*</span>
                              </label>

                              <v-checkbox :disabled="someParamsVisible" v-model="flag" @change="allFranchisee" label="All Franchisee"></v-checkbox>

                              <div class="control is-fullwidth">
                                <multiselect
                                  :disabled="someParamsVisible"
                                  track-by="id"
                                  label="companyName"
                                  class="overflowmultiselect1"
                                  :close-on-select="false"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  :preselect-first="false"
                                  :multiple="true"
                                  :options="franchiseeArr"
                                  :optionHeight="15"
                                  :max-height="100"
                                  v-model="franchiseeIDs"
                                  @remove="removeCheckFranchisee"
                                >
                                  >
                                  <template slot="selection" slot-scope="{ values, isOpen }"
                                    ><span class="multiselect__single" v-if="values.role &amp;&amp; !isOpen">{{ values.companyName }} </span></template
                                  >
                                </multiselect>
                              </div>
                            </div>
                          </div>
                        </div>

                        <footer class="column has-text-left">
                          <button class="button is-success" type="submit">Save</button>
                        </footer>
                      </card-component>
                    </div>
                  </form>
                </section>
              </div>
            </template>
          </div>
        </div>
      </b-modal>
    </template>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Application Amount Setting</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <router-link :to="{ name: 'settingView' }" class="button is-small is-link">Back to Settings</router-link>
          </div>
          <div class="level-item">
            <button class="button is-info is-small btnicon" @click="ModalOpen()" title="Add">
              Create Application Fee
            </button>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column ">
          <drop-down type="forAcadmicYear" @change="onchanging"></drop-down>
        </div>
        <div class="column is-6">
          <drop-down type="forFranchiseeSelection" @change="onchanging"></drop-down>
        </div>
      </div>
      Total Records :
      <b>{{ total }}</b>
    </section>

    <section class="section is-main-section">
      <card-component title class="has-table has-mobile-sort-spaced">
        <b-table paginated :per-page="perPage" :striped="true" :hoverable="true" :data="info" style="overflow-x:scroll">
          <template slot-scope="props">
            <b-table-column field="adjustOrder" label="Class" sortable>
              <b-tag type="is-success">{{ props.row.studentClass.name }}</b-tag></b-table-column
            >
            <b-table-column field="franchisee.companyName" label="Franchisee" sortable>
              <b-tag type="is-info">{{ props.row.franchisee.companyName }} </b-tag></b-table-column
            >
            <b-table-column field="name" label="Amount" sortable> {{ props.row.amount }} </b-table-column>

            <b-table-column field="amountOrPercentage" label="Admission Type" sortable> {{ props.row.admissionType }}</b-table-column>

            <b-table-column label="Action">
              <a @click="getEditinfo(props.row.id)"> Adjust Settings</a>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>Nothing here.</p>
              </div>
            </section>
          </template>
        </b-table>
      </card-component>
    </section>
  </div>
</template>
<script>
import Utils from '@/utils'
import store from '@/store'
import Multiselect from 'vue-multiselect'
import constants from '@/utils/constants'
import DropDown from '../../reusableComp/dropDown'
import CardComponent from '@/components/template/CardComponent'
import _ from 'lodash'

export default {
  name: 'ApplicationSetting',
  components: {
    DropDown,
    Multiselect,
    CardComponent
  },
  data () {
    return {
      tots_image: constants.RAZORPAY.TOTS_IMAGE,
      academicYears: [],
      franchiseeArr: [],
      amount: '',
      admissionType: '',

      info: [],
      modalOk: false,

      franchiseeIDs: [],

      classes: [],
      classIDs: [],
      title: '',
      total: 0,
      paginated: false,
      perPage: 10,
      loadingComponent: null,
      someParamsVisible: false,
      id: '',
      flag: ''
    }
  },

  watch: {
    franchiseeID: function (values) {
      if (!values) {
        this.total = 0
        this.info = []
      }
    },
    academicYearID: function (values) {
      if (!values) {
        this.total = 0
        this.info = []
      }
    },
    franchiseeIDs: async function () {
      if (this.franchiseeArr.length === this.franchiseeIDs.length) {
        this.flag = true
      }
    }
  },

  computed: {
    academicYearID: {
      get () {
        return store.state.feeComponent.academicYearID
      },
      set (value) {
        store.commit('updateAcadmicYrId', value)
      }
    },
    franchiseeID: {
      get () {
        return store.state.feeComponent.franchiseeID
      },
      set (value) {
        store.commit('updateFranchiseeID', value)
      }
    }
  },
  async created () {
    this.$store.dispatch('getCurrentAcadmicYearID')
    await this.getAcademicYears()
  },
  methods: {
    closing: function () {
      this.academicYearID = this.academicYearID
      this.modalOk = false
      this.onchanging()
    },
    exceptEValidation: function (event) {
      if (event.target.value === '') {
        event.target.value = ''
        return event
      }
    },

    getEditinfo: async function (id) {
      try {
        this.id = id
        this.modalOk = true
        this.someParamsVisible = true
        this.title = 'Adjust Application Settings'
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/fee-application-setting/${id}`)
        this.loadingComponent.close()
        this.amount = data.amount
        this.admissionType = data.admissionType
        this.classIDs = data.studentClass
        this.franchiseeIDs = data.franchisee
        this.academicYearID = data.academicYearID
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e
        console.log(errorMessage)
        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    async ModalOpen () {
      this.modalOk = true

      this.someParamsVisible = false
      this.title = 'Create Application Settings'
      await this.getFranchiseeList()
      await this.getClassList()
      this.total = 0
      this.info = []
      this.classIDs = []

      this.franchiseeIDs = []
      this.amount = []
      this.flag = false
    },

    getClassList: async function () {
      try {
        const classes = await http.get(`${constants.API_URL}/api/students/class`)

        this.classes = classes.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    onchanging: async function () {
      try {
        if (this.franchiseeID === '' || this.academicYearID === '') {
          return this.$buefy.toast.open({
            message: 'Please select below details',
            type: 'is-danger',
            duration: 4000
          })
        }
        this.loadingComponent = this.$buefy.loading.open()

        const { data } = await http.get(`${constants.API_URL}/api/fee-application-setting?franchiseeID=${this.franchiseeID}&academicYearID=${this.academicYearID}`)

        this.loadingComponent.close()
        this.info = data
        if (!this.info) {
          this.total = 0
        } else {
          this.total = this.info.length
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getAcademicYears: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.loadingComponent.close()
        this.academicYears = data.rows

        const currentAcademicYear = Utils.getCurrentAcademicYear()

        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getFranchiseeList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.loadingComponent.close()
        this.franchiseeArr = data.rows

        if (this.franchiseeArr.length > 1) {
          this.franchiseeArr = data.rows
        } else {
          this.franchiseeID = this.franchiseeArr[0].id
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    saveSettings: async function () {
      let formData = {
        amount: this.amount
      }
      if (this.title === 'Adjust Application Settings') {
        try {
          this.loadingComponent = this.$buefy.loading.open()
          await http.put(`${constants.API_URL}/api/fee-application-setting/${this.id}`, formData)

          this.loadingComponent.close()
          this.modalOk = false
          this.onchanging()
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: errorMessage,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } else {
        formData.franchiseeID = _.map(this.franchiseeIDs, 'id')
        formData.classID = _.map(this.classIDs, 'id')
        formData.academicYearID = this.academicYearID
        formData.admissionType = this.admissionType
        try {
          console.log(this.classIDs, 'classIDs')
          if (_.isEmpty(this.classIDs)) {
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: 'Class cannot be blank',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }

          if (_.isEmpty(this.franchiseeIDs)) {
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: 'Franchisee cannot be blank',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
          this.loadingComponent = this.$buefy.loading.open()
          await http.post(`${constants.API_URL}/api/fee-application-setting/`, formData)

          this.loadingComponent.close()
          this.modalOk = false
          this.onchanging()
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: errorMessage,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      }
    },
    allFranchisee: function () {
      let franchiseeArray = []
      if (this.flag === true) {
        this.franchiseeArr.forEach(Obj => {
          franchiseeArray.push(Obj)
        })
        this.flag = true
      }
      this.franchiseeIDs = franchiseeArray
    },
    removeCheckFranchisee: function () {
      this.flag = false
      return true
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
